/**
 * Minimal hash router. Patterns use :params, e.g. "/gallery/:id".
 * router.add("/gallery/:id", ({ id }) => ...); router.go("/gallery/abc");
 */
class Router {
  constructor() {
    this.routes = [];
    this.fallback = null;
  }

  add(pattern, handler) {
    const keys = [];
    const regex = new RegExp(
      "^" +
        pattern.replace(/:[^/]+/g, (m) => {
          keys.push(m.slice(1));
          return "([^/]+)";
        }) +
        "$"
    );
    this.routes.push({ regex, keys, handler });
    return this;
  }

  setFallback(handler) {
    this.fallback = handler;
    return this;
  }

  /** Returns the first route's handler promise so callers can await initial content. */
  init() {
    window.addEventListener("hashchange", () => this.resolve());
    return this.resolve();
  }

  go(path) {
    if (location.hash.slice(1) === path) this.resolve();
    else location.hash = path;
  }

  /**
   * Like go(), but overwrites the current history entry instead of adding one.
   * Use for redirects (a guard bouncing a visitor, a bare path forwarding to a
   * default) — otherwise Back returns to the path that redirects, which
   * immediately redirects again and traps the button.
   */
  replace(path) {
    if (location.hash.slice(1) === path) this.resolve();
    else location.replace(`#${path}`);
  }

  current() {
    return location.hash.slice(1) || "/";
  }

  resolve() {
    const path = this.current();
    for (const { regex, keys, handler } of this.routes) {
      const m = path.match(regex);
      if (m) {
        const params = {};
        keys.forEach((k, i) => (params[k] = decodeURIComponent(m[i + 1])));
        return handler(params);
      }
    }
    this.fallback?.(path);
  }
}

export default new Router();
